import { Component, ElementRef, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface DialogData {
	cardExplanationIconRef: ElementRef,
	explanationText: string,
	drawToBottom: boolean,
	drawToTopRight: boolean,
}

@Component({
    selector: 'explanation-modal-dialog',
    templateUrl: 'explanation-modal.component.html',
    styleUrls: ['./explanation-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExplanationModalComponent implements OnInit {

	public explanationText: string;

	private positionRelativeToElement: any;
	private drawToBottom = false;
	private drawToTopRight = false;

	get lang() {
		return window.location.pathname.split('/')[2];
	}

	constructor(public dialogRef: MatDialogRef<ExplanationModalComponent>,
				@Inject(MAT_DIALOG_DATA) public data: DialogData
	) {
		this.positionRelativeToElement = this.data.cardExplanationIconRef;
		this.explanationText = this.data.explanationText;
		this.drawToBottom = this.data.drawToBottom;
		this.drawToTopRight = this.data.drawToTopRight;
	}

	ngOnInit(): void {
		const rect: DOMRect = this.positionRelativeToElement.getBoundingClientRect();
		const position = this.drawToBottom ? {top: `${rect.top + 30}px`, left: `${rect.left - 120}px`}
			: (this.drawToTopRight ? {top: `${rect.top - 300}px`, left: `${rect.left}px`}
				: {top: `${rect.top}px`, left: `${rect.left - 300}px`})
		this.dialogRef.updatePosition(position);
	}
}
